import { render, staticRenderFns } from "./BundleMappingSettings.vue?vue&type=template&id=5b1e9cea"
import script from "./BundleMappingSettings.vue?vue&type=script&lang=ts"
export * from "./BundleMappingSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports